export default __webpack_public_path__ + "static/media/Power_MKozłowska.14e9eefa.pdf";